import * as React from 'react';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Typography, Menu, MenuItem, MenuList, Box } from '@mui/material';

export default function DropMenu({ model, icon }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return (
        <Box sx={{ position: 'relative' }}>
            <Box sx={{ cursor: 'pointer' }} onClick={handleClick}>
                {icon || "click here"}
            </Box>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                disableScrollLock
                transitionDuration={180}
                slotProps={{
                    paper: {
                        sx: {
                            mt: 1,
                            minWidth: 180,
                            background: '#ffffff',
                            border: '1px solid #e2e8f0',
                            borderRadius: '14px',
                            boxShadow: '0 8px 32px rgba(15,23,42,0.08)',
                            overflow: 'hidden',
                            animation: 'scaleIn 0.18s cubic-bezier(0.4,0,0.2,1)',
                        },
                    },
                }}
            >
                <MenuList disablePadding sx={{ py: 0.5 }}>
                    {model.map((m, index) => (
                        <React.Fragment key={index}>
                            {/* Divider after first item (username) */}
                            {index === 1 && (
                                <Divider sx={{ borderColor: '#f1f5f9', my: 0.5 }} />
                            )}
                            {/* Divider before last item (logout) */}
                            {index === model.length - 1 && (
                                <Divider sx={{ borderColor: '#f1f5f9', my: 0.5 }} />
                            )}
                            <MenuItem
                                onClick={() => { m.command(); handleClose(); }}
                                disabled={index === 0}
                                sx={{
                                    borderRadius: '10px',
                                    mx: 0.5,
                                    px: 1.5,
                                    py: 1,
                                    color: index === model.length - 1 ? '#dc2626' : '#475569',
                                    fontSize: 14,
                                    fontFamily: 'Inter, sans-serif',
                                    fontWeight: 400,
                                    transition: 'all 0.15s ease',
                                    '&:hover': {
                                        background: index === model.length - 1
                                            ? '#fef2f2'
                                            : '#f1f5f9',
                                        color: index === model.length - 1 ? '#dc2626' : '#0f172a',
                                    },
                                    '&.Mui-disabled': {
                                        opacity: 1,
                                        color: '#1e293b',
                                        fontWeight: 650,
                                        fontSize: 13,
                                        letterSpacing: '0.04em',
                                        cursor: 'default',
                                        py: 1.2,
                                    }
                                }}
                            >
                                <ListItemIcon sx={{ minWidth: 30, color: 'inherit' }}>
                                    {m.icon}
                                </ListItemIcon>
                                <ListItemText>
                                    {m.label}
                                </ListItemText>
                            </MenuItem>
                        </React.Fragment>
                    ))}
                </MenuList>
            </Menu>
        </Box>
    );
}
